import { render, staticRenderFns } from "./BattleWaitList.vue?vue&type=template&id=e4833e9e&scoped=true"
import script from "./BattleWaitList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BattleWaitList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BattleWaitList.vue?vue&type=style&index=0&id=e4833e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4833e9e",
  null
  
)

export default component.exports